import React, { useRef, useState,useEffect } from "react";
import { useNavigate } from "react-router-dom"; // Import useNavigate hook
import "bootstrap/dist/css/bootstrap.min.css";
import Select from "react-select";
import { ApiUrl } from "../../../ApiUrl";
import ReactPaginate from "react-paginate";
import * as XLSX from "xlsx";
import jsPDF from "jspdf";
import "jspdf-autotable";

const AdmAttendanceEntry = () => {

  const [employeeData, setEmployeeData] = useState([]);
  const [employeeTypeOptions, setEmployeeTypeOptions] = useState([]);
  const [statusOptions, setStatusOptions] = useState([
    { value: "active", label: "Active" },
    { value: "inactive", label: "Inactive" },
    // { value: "terminated", label: "Terminated" },
  ]);
  const navigate = useNavigate(); // Initialize the navigate function
  const [searchParams, setSearchParams] = useState({
    employeeCode: "",
    firstName: "",
    middleName: "",
    lastName: "",
    employeeType: null, // for react-select
    employeeStatus: null,
  });  const [quickSearchQuery, setQuickSearchQuery] = useState("");  


  const dateFromRef = useRef(null);
  const dateToRef = useRef(null);
  const messageTypeRef = useRef(null);
  const studentNameRef = useRef(null);
  const initiatedByRef = useRef(null);
  const sectionRef = useRef(null);
  const classRef = useRef(null);
  const itemsPerPage = 10; // You can change this value
  const [currentPage, setCurrentPage] = useState(0);

  // Calculate total pages
  const filteredEmployeeData = employeeData.filter((employee) => {
    const query = quickSearchQuery.trim().toLowerCase();
    if (!query) return true;

    const employeeCode = employee.employee_code || "";
    const employeeName = employee.employee_name || "";
    const employeeType = employee.employee_type || "";
    const email = employee.email || "";
    const phone = employee.phone_number || "";

    return [
      employeeCode,
      employeeName,
      employeeType,
      email,
      phone,
    ]
      .join(" ")
      .toLowerCase()
      .includes(query);
  });

  const pageCount = Math.ceil(filteredEmployeeData.length / itemsPerPage);

  // Get current page data
  const getCurrentPageData = () => {
    const start = currentPage * itemsPerPage;
    const end = start + itemsPerPage;
    return filteredEmployeeData.slice(start, end);
  };

  // Handle page change
  const handlePageClick = ({ selected }) => {
    setCurrentPage(selected);
  };

  const handleClear = () => {
  setSearchParams({
    employeeCode: "",
    firstName: "",
    middleName: "",
    lastName: "",
    employeeType: null,
    employeeStatus: null,
  });
  setQuickSearchQuery("");
  setCurrentPage(0);
  fetchEmployeeData();
};



  const handleNew = () => {
    navigate("/AdmStaffDetails"); 
  };

  const handleClose = () => {
  navigate(-1); // go back to previous page
};

  const handleExportToExcel = () => {
    if (employeeData.length === 0) {
      alert("No employee data available to export.");
      return;
    }

    const exportData = employeeData.map((employee, index) => ({
      "Sr. No": index + 1,
      "Employee Code": employee.employee_code || "",
      "Name": employee.employee_name || "",
      "Employee Type": employee.employee_type || "",
      "Date Of Birth": employee.dob || "",
      "Mobile No": employee.phone_number || "",
      "Email ID": employee.email || "",
      "Date Of Joining": employee.date_of_joining || "",
    }));

    const worksheet = XLSX.utils.json_to_sheet(exportData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Employee Search");
    XLSX.writeFile(workbook, "Employee_Search.xlsx");
  };

  const handleExportToPDF = () => {
    if (employeeData.length === 0) {
      alert("No employee data available to export.");
      return;
    }

    const doc = new jsPDF("p", "pt", "a4");
    const tableColumn = [
      "Sr. No",
      "Employee Code",
      "Name",
      "Employee Type",
      "Date Of Birth",
      "Mobile No",
      "Email ID",
      "Date Of Joining",
    ];
    const tableRows = employeeData.map((employee, index) => [
      index + 1,
      employee.employee_code || "",
      employee.employee_name || "",
      employee.employee_type || "",
      employee.dob || "",
      employee.phone_number || "",
      employee.email || "",
      employee.date_of_joining || "",
    ]);

    doc.autoTable({
      head: [tableColumn],
      body: tableRows,
      startY: 40,
      styles: { fontSize: 8 },
      headStyles: { fillColor: [21, 101, 216], textColor: 255, halign: "center" },
      alternateRowStyles: { fillColor: [248, 250, 252] },
    });
    doc.text("Employee Search Report", 40, 30);
    doc.save("Employee_Search.pdf");
  };

  useEffect(() => {
    const fetchEmployeeTypes = async () => {
      try {
        const response = await fetch(
          `${ApiUrl.apiurl}STAFF/EmployeeTypeList/`
        );
        const result = await response.json();

        if (response.ok && result.data) {
          // Map API response to react-select format
          const formattedOptions = result.data.map((item) => ({
            value: item.employee_type_id,
            label: item.employee_type,
          }));
          setEmployeeTypeOptions(formattedOptions);
        } else {
          console.error("Failed to load employee types:", result);
        }
      } catch (error) {
        console.error("Error fetching employee types:", error);
      }
    };

    fetchEmployeeTypes();
  }, []);


  const fetchEmployeeData = async () => {
    try {
      const orgId = localStorage.getItem("orgId") || "1";
      const branchId = localStorage.getItem("branchId") || "1";

      const params = new URLSearchParams({
        org_id: orgId,
        branch_id: branchId,
      });

      // Optional search params
      if (searchParams.employeeCode)
        params.append("employee_code", searchParams.employeeCode);
      if (searchParams.firstName)
        params.append("first_name", searchParams.firstName);
      if (searchParams.middleName)
        params.append("middle_name", searchParams.middleName);
      if (searchParams.lastName)
        params.append("last_name", searchParams.lastName);
      if (searchParams.employeeType?.value)
        params.append("employee_type", searchParams.employeeType.value);
      if (searchParams.employeeStatus?.value)
        params.append("status", searchParams.employeeStatus.value);

      const response = await fetch(
        `${ApiUrl.apiurl}STAFF/registrationstaffList/?${params.toString()}`
      );

      const result = await response.json();
      if (response.ok && result.data) {
        setEmployeeData(Array.isArray(result.data) ? result.data : []);
      } else {
        console.error("Failed to fetch employee data:", result);
      }
    } catch (error) {
      console.error("Error fetching employee data:", error);
    }
  };

  useEffect(() => {
    // Load initial list only once on mount.
    fetchEmployeeData(); // Load all data when page opens
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);


  // const handleEdit = async (employeeId) => {
  //   try {
  //     const response = await fetch(
  //       `${ApiUrl.apiurl}STAFF/registrationBasicDetailsRetreive/${employeeId}/`
  //     );
  //     const result = await response.json();

  //     if (response.ok && result.data) {
  //       setEditData(result.data); // Set response in state
  //       navigate("/AdmStaffDetails", {
  //         state: { employeeDetails: result.data },
  //       }); // Pass via location state
  //     } else {
  //       console.error("Failed to fetch employee details:", result);
  //     }
  //   } catch (error) {
  //     console.error("Error fetching employee details:", error);
  //   }
  // };
  
const handleEdit = async (employeeId) => {
  try {
    const response = await fetch(
      `${ApiUrl.apiurl}STAFF/registrationRetrieveUnified/${employeeId}/`
    );
    const result = await response.json();

    if (response.ok && result.data) {
      const basicDetails = result.data.basicDetails || {};

      navigate("/AdmStaffDetails", {
        state: {
          employeeId,
          employeeDetails: basicDetails,
          unifiedData: result.data,
        },
      });
    } else {
      console.error("Failed to fetch employee details:", result);
    }
  } catch (error) {
    console.error("Error fetching employee details:", error);
  }
};



  return (
    <div className="container-fluid">
      <div className="row">
        <div className="col-12">
          <div className="card p-0">
            <div className="card-body">
              <p
                style={{
                  marginBottom: "0px",
                  textAlign: "center",
                  fontSize: "20px",
                  fontWeight: "700",
                }}
              >
                EMPLOYEE SEARCH
              </p>
              <div className="row mb-3 mt-3 mx-0">
                <div className="col-12 d-flex flex-wrap gap-2">
                  <button
                    type="button"
                    className="btn btn-primary me-2"
                    style={{
                      width: "150px",
                    }}
                    onClick={handleNew} // Add the onClick event to trigger navigation
                  >
                    New
                  </button>
                  <button
                    type="button"
                    className="btn btn-primary me-2"
                    style={{
                      width: "150px",
                    }}
                    onClick={fetchEmployeeData}
                  >
                    Search
                  </button>
                  <button
                    type="button"
                    className="btn btn-secondary me-2"
                    style={{
                      width: "150px",
                    }}
                    onClick={handleClear}
                  >
                    Clear
                  </button>
                  <button
                    type="button"
                    className="btn btn-primary me-2"
                    style={{
                      width: "150px",
                    }}
                    onClick={handleExportToExcel}
                  >
                    Export to Excel
                  </button>
                  <button
                    type="button"
                    className="btn btn-primary me-2"
                    style={{
                      width: "150px",
                    }}
                    onClick={handleExportToPDF}
                  >
                    Export to PDF
                  </button>
                  <button
                    type="button"
                    className="btn btn-danger me-2"
                    style={{
                      width: "150px",
                    }}
                    onClick={handleClose}
                  >
                    Close
                  </button>
                </div>
              </div>

              <div className="row mt-3 mx-2">
                <div className="col-12 custom-section-box">
                  <div className="d-flex flex-column flex-md-row align-items-start align-items-md-center">
                    <div className="row flex-grow-1 mt-3  mb-3">
                      <div className="col-md-3 mb-3">
                        <label htmlFor="employee-code" className="form-label">
                          Employee Code
                        </label>
                        <div className="d-flex align-items-center">
                          <input
                            type="text"
                            id="employee-code"
                            className="form-control detail"
                            placeholder="Enter employee code"
                            value={searchParams.employeeCode}
                            onChange={(e) =>
                              setSearchParams({
                                ...searchParams,
                                employeeCode: e.target.value,
                              })
                            }
                          />
                        </div>
                      </div>

                      <div className="col-12 col-md-5 mb-3 ">
                        <label htmlFor="student-name" className="form-label">
                          Employee Name
                        </label>
                        <div className="d-flex align-items-center">
                          <input
                            type="text"
                            className="form-control detail ms-2"
                            placeholder="Enter First name"
                            value={searchParams.firstName}
                            onChange={(e) =>
                              setSearchParams({
                                ...searchParams,
                                firstName: e.target.value,
                              })
                            }
                          />
                          <input
                            type="text"
                            className="form-control detail ms-2"
                            placeholder="Enter Middle name"
                            value={searchParams.middleName}
                            onChange={(e) =>
                              setSearchParams({
                                ...searchParams,
                                middleName: e.target.value,
                              })
                            }
                          />
                          <input
                            type="text"
                            className="form-control detail ms-2"
                            placeholder="Enter Last name"
                            value={searchParams.lastName}
                            onChange={(e) =>
                              setSearchParams({
                                ...searchParams,
                                lastName: e.target.value,
                              })
                            }
                          />
                        </div>
                      </div>
                      <div className="col-12 col-md-3 mb-3">
                        <label htmlFor="employee-type" className="form-label">
                          Employee Type
                        </label>
                        <Select
                          inputId="employee-type"
                          className="detail"
                          classNamePrefix="employee-type-select"
                          options={employeeTypeOptions}
                          value={searchParams.employeeType}
                          onChange={(selectedOption) =>
                            setSearchParams({
                              ...searchParams,
                              employeeType: selectedOption,
                            })
                          }
                        />
                      </div>
                      <div className="col-12 col-md-3 mb-3">
                        <label htmlFor="employee-status" className="form-label">
                          Status
                        </label>
                        <Select
                          inputId="employee-status"
                          className="detail"
                          classNamePrefix="employee-status-select"
                          options={statusOptions}
                          value={searchParams.employeeStatus}
                          onChange={(selectedOption) =>
                            setSearchParams({
                              ...searchParams,
                              employeeStatus: selectedOption,
                            })
                          }
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="row mt-3 mx-2">
                <div className="col-12">
                  <label htmlFor="quick-search" className="form-label">
                
                  </label>
                  <input
                    id="quick-search"
                    type="text"
                    className="form-control mb-3"
                    placeholder="Search by name, employee code, type, email, phone..."
                    value={quickSearchQuery}
                    onChange={(e) => {
                      setQuickSearchQuery(e.target.value);
                      setCurrentPage(0);
                    }}
                  />
                </div>
              </div>

              <div className="row">
                <div className="col-12">
                  <div className="table-responsive">
                    <table className="table table-bordered">
                      <thead>
                        <tr>
                          <th>Sr.No</th>
                          <th>Employee Code</th>
                          <th>Name</th>
                          <th>Employee Type</th>
                          <th>Date Of Birth</th>
                          <th>Mobile No</th>
                          <th>Email ID</th>
                          <th>Date Of Joining</th>
                          <th>Edit</th>
                        </tr>
                      </thead>
                      <tbody>
                        {getCurrentPageData().length > 0 ? (
                          getCurrentPageData().map((employee, index) => (
                            <tr key={employee.employee_id}>
                              <td>{currentPage * itemsPerPage + index + 1}</td>
                              <td>{employee.employee_code}</td>
                              <td>{employee.employee_name}</td>
                              <td>{employee.employee_type}</td>
                              <td>{employee.dob}</td>
                              <td>{employee.phone_number}</td>
                              <td>{employee.email}</td>
                              <td>{employee.date_of_joining}</td>
                              <td>
                                <button
                                  className="btn btn-primary btn-sm"
                                  onClick={() => handleEdit(employee.id)}
                                >
                                  Edit
                                </button>
                              </td>
                            </tr>
                          ))
                        ) : (
                          <tr>
                            <td colSpan={9} className="text-center">
                              No Data Found
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>

                  {/* Pagination */}
                  <ReactPaginate
                    previousLabel={"Previous"}
                    nextLabel={"Next"}
                    breakLabel={"..."}
                    breakClassName={"page-item"}
                    breakLinkClassName={"page-link"}
                    pageCount={pageCount}
                    marginPagesDisplayed={2}
                    pageRangeDisplayed={5}
                    onPageChange={handlePageClick}
                    containerClassName={
                      "pagination justify-content-center mt-3"
                    }
                    pageClassName={"page-item"}
                    pageLinkClassName={"page-link"}
                    previousClassName={"page-item"}
                    previousLinkClassName={"page-link"}
                    nextClassName={"page-item"}
                    nextLinkClassName={"page-link"}
                    activeClassName={"active"}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdmAttendanceEntry;
